module.exports = __webpack_public_path__ + "static/img/product.4a12899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product.png
// module id = E38b
// module chunks = 2